import ScheduleDto from "../../../dtos/schedulermodule/ScheduleDto";
import DataTableReadDto from "../../../dtos/pathcommonmodule/DataTableReadDto";
import PathSynchroMappingDto from "../../../dtos/pathsynchromodule/PathSynchroMappingDto";
import PathSynchroSetupDto from "../../../dtos/pathsynchromodule/PathSynchroSetupDto";

class GetPathSynchroDetailResult {
    Id: number;
    Name: string;
    Source: DataTableReadDto | null;
    Target: DataTableReadDto | null;
    Mappings: PathSynchroMappingDto[];
    Schedule: ScheduleDto;
    Setup: PathSynchroSetupDto;
    AdvancedFilterMode: boolean;
    LastVersionId: number | null;
    PublishedVersionId: number | null;

    constructor(id: number, name: string, source: DataTableReadDto | null, target: DataTableReadDto | null, mappings: PathSynchroMappingDto[], schedule: ScheduleDto, setup: PathSynchroSetupDto, lastVersionId: number | null, publishedVersionId: number | null, advancedFilterMode: boolean) {
        this.Id = id;
        this.Name = name;
        this.Source = source;
        this.Target = target;
        this.Mappings = mappings;
        this.Schedule = schedule;
        this.Setup = setup;
        this.LastVersionId = lastVersionId;
        this.PublishedVersionId = publishedVersionId;
        this.AdvancedFilterMode = advancedFilterMode;
    }
}

export default GetPathSynchroDetailResult;
